import { MouseEvent } from "react";
import { ReactComponent as MoreIconVertical } from "../icons/moreIconVertical.svg";
import "./buttons.scss";

export const MoreButton = (props: {
  onClick: (event: MouseEvent<HTMLButtonElement>) => void;
  id?: string;
}): JSX.Element => {
  return (
    <button
      id={props.id}
      className="rg-button more"
      title="Show more options"
      onClick={props.onClick}
    >
      <MoreIconVertical />
    </button>
  );
};
